import { Observable, firstValueFrom, timeout } from 'rxjs';

export function awaitRegistrationOffer<T>(response$: Observable<T>, deadlineMs = 20000): Promise<T> {
  return firstValueFrom(response$.pipe(timeout(deadlineMs)));
}
